import {
  Radio as HeadlessRadio,
  type RadioProps as HeadlessRadioProps,
} from "@headlessui/react";
import classNames from "classnames";
import type { ReactNode } from "react";

import type { GroupPrivacy } from "./types";

export default function GroupPrivacyRadio({
  title,
  description,
  icon,
  ...props
}: {
  title: string;
  description: string;
  icon: ReactNode;
} & HeadlessRadioProps<"div", GroupPrivacy>) {
  return (
    <HeadlessRadio
      {...props}
      className={({ checked }) =>
        classNames(
          "flex cursor-pointer flex-col gap-2 rounded-xl border p-4 select-none",
          "ring-primary-100 focus:ring-4 focus:outline-hidden",
          checked
            ? "border-primary-600 bg-primary-50 border-2"
            : "border border-gray-200",
        )
      }
    >
      {({ checked }) => (
        <>
          <div className="flex items-center gap-3">
            <div
              className={classNames(
                "flex size-8 shrink-0 items-center justify-center rounded-full",
                checked
                  ? "bg-primary-100 text-primary-600"
                  : "bg-gray-100 text-gray-600",
              )}
            >
              {icon}
            </div>
            <span
              className={classNames(
                "flex-1 text-sm font-medium",
                checked ? "text-primary-800" : "text-gray-700",
              )}
            >
              {title}
            </span>
            <div
              className={classNames(
                "flex size-4 shrink-0 items-center justify-center rounded-full border",
                checked
                  ? "border-primary-600 bg-primary-50"
                  : "border-gray-300 bg-white",
              )}
            >
              {checked && (
                <div className="bg-primary-600 size-1.5 rounded-full" />
              )}
            </div>
          </div>
          <p
            className={classNames(
              "text-sm",
              checked ? "text-primary-700" : "text-gray-600",
            )}
          >
            {description}
          </p>
        </>
      )}
    </HeadlessRadio>
  );
}
